// React Imports
import React, { useEffect, useState } from "react";

// Router Imports
import { useNavigate } from "react-router-dom";

// Redux Imports
import { useDispatch } from "react-redux";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";

// Utils Imports
import { GlobalConfiguration } from "../../../utils/configurationProvider";

// Component Imports
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import ICONS from "../../../assets/Icons";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";

const FieldForceRequestMultiApprovalSuccess = () => {
  // 1️⃣ useNavigate & useDispatch
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 2️⃣ useState
  const [successPageData, setsuccessPageData] = useState([]);
  const [successPageID, setsuccessPageID] = useState([]);
  const [approvedTransactions, setApprovedTransactions] = useState([]);

  // 3️⃣ Callback / Handler functions
  const goToDashboard = () => {
    navigate("/field_force_transaction_dashboard");
  };

  const approveMoreTransactions = () => {
    navigate(
      "/field_force_transaction_dashboard/field_force_request_multi_approval",
    );
    // CommonToast({
    //   text: "Feature coming soon",
    //   icon: ICONS?.INFO,
    //   variant: "var(--coming-soon)",
    //   buttonNeeded: false,
    // });
  };

  const buttonRows = [
    [
      {
        btnText: "Go to request approval",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: approveMoreTransactions,
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  // 4️⃣ useEffect
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementRequestTxnData"),
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved",
      );
      setsuccessPageData(storedSelectedApproval?.selectedSendTransactions);
      setApprovedTransactions(approved);
      setsuccessPageID(storedSelectedApproval.selectedTransactions);
    } else {
      setsuccessPageData([]);
      setsuccessPageID([]);
    }
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <>
      <StatusContainer
        status="success"
        title={
          successPageData.length &&
          "Requests approved and transactions created successfully."
        }
        buttonRows={buttonRows}
      >
        {approvedTransactions?.length >
          GlobalConfiguration?.lengthCheckZero && (
          <TabsWeapperSection
            title={`Approved and created  - ${successPageID.length}`}
          >
            <div className="flex flex-col">
              {successPageData.map((account, i) => (
                <InfoCard
                  key={account?.request_id || i}
                  bgColor="var(--positive-card)"
                  hoverable="white"
                  onClick={() =>
                    navigate(
                      `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${account?.request_id}`,
                    )
                  }
                  rows={[
                    {
                      leftTitle: account?.field_force_account_name,
                      leftSubTitle: "Account name",
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      hasRight: true,
                      rightIcon: true,
                      rightText: true,
                      rightTitle: `INR ${FormatAmount({ price: account?.requested_amount })}`,
                      rightSubTitle: "Amount",
                      onClick: () =>
                        navigate(
                          `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${account?.request_id}`,
                        ),
                    },
                  ]}
                />
              ))}
            </div>
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </>
  );
};

export default FieldForceRequestMultiApprovalSuccess;
